import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { toast } from "sonner";

export default function Continue() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (loading) return;
    if (!user) { nav("/login"); return; }
    api.get("/user/continue").then((r) => setData(r.data)).catch(() => {});
  }, [user, loading, nav]);

  if (!data) {
    return <div className="min-h-[70vh] flex items-center justify-center px-6" style={{ color: "var(--ink-soft)" }}>loading…</div>;
  }

  const pct = Math.round((data.completed_count / (data.total || 1)) * 100);

  if (data.all_done) {
    const shareLine = "i just finished showgirl desire.";
    const copyLine = async () => {
      try { await navigator.clipboard.writeText(shareLine); setCopied(true); toast.success("copied"); } catch { toast.error("copy failed"); }
    };
    return (
      <div className="min-h-[85vh] flex items-center justify-center px-6 py-16" data-testid="completion-screen">
        <div className="max-w-xl text-center">
          <p className="text-xs uppercase tracking-[0.3em] mb-4" style={{ color: "var(--gold)" }}>the workshop, complete</p>
          <h1 className="font-serif text-5xl sm:text-6xl mb-6" style={{ color: "var(--ink)" }}>you did it.</h1>
          <p className="text-lg mb-8" style={{ color: "var(--ink-soft)" }}>
            all thirteen lessons and every practice. the essay, the exercise, the return. the respectability bargain is over. welcome back.
          </p>
          <div className="border-t border-b py-6 my-6" style={{ borderColor: "var(--gold-soft)" }}>
            <p className="text-xs uppercase tracking-widest mb-3" style={{ color: "var(--gold)" }}>share the line</p>
            <p className="font-serif text-2xl mb-4" style={{ color: "var(--ink)" }} data-testid="share-line">
              &ldquo;{shareLine}&rdquo;
            </p>
            <button onClick={copyLine} className="btn-ghost" data-testid="copy-share">
              {copied ? "copied" : "copy line"}
            </button>
          </div>
          <div className="flex flex-wrap gap-4 justify-center">
            <Link to="/course" className="btn-primary" data-testid="continue-open-course">re-open the course</Link>
            <Link to="/favorites" className="btn-ghost" data-testid="continue-favorites">lines i loved</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6 py-16" data-testid="continue-screen">
      <div className="max-w-lg text-center">
        <p className="text-xs uppercase tracking-[0.3em] mb-4" style={{ color: "var(--gold)" }}>welcome back</p>
        <h1 className="font-serif text-4xl sm:text-5xl mb-4" style={{ color: "var(--ink)" }}>where you left off.</h1>
        <p className="mb-8" style={{ color: "var(--ink-soft)" }}>
          {data.completed_count === 0
            ? "start with the introduction. one lesson at a time."
            : `${data.completed_count} of ${data.total} lessons done — ${pct}%.`}
        </p>
        <button
          onClick={() => nav(`/course/${data.next.id}`)}
          className="btn-primary"
          data-testid="continue-btn"
        >
          continue: {data.next.title}
        </button>
        <div className="mt-6">
          <Link to="/course" className="text-sm underline" style={{ color: "var(--ink-soft)" }} data-testid="see-all">
            see all lessons
          </Link>
        </div>
      </div>
    </div>
  );
}
